<template>
    <div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label>调拨单号</label>
                </div>
                <div class="form-value">
                    <span>{{ transVoucherInfo.innerNo }}</span>
                </div>
            </div>
            <div class="form-group center" v-if="transVoucherInfo.srcVoucherType != null">
                <div class="form-label">
                    <label>来源单据号</label>
                </div>
                <div class="form-value">
                    <span>{{ transVoucherInfo.srcVoucherNo }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>外部单据号</label>
                </div>
                <div class="form-value">
                    <span>{{ transVoucherInfo.outerNo || '无' }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>调出机构</label>
                </div>
                <div class="form-value">
                    <span>{{ transVoucherInfo.srcBizUnitName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>调入机构</label>
                </div>
                <div class="form-value">
                    <span>{{ transVoucherInfo.dstBizUnitName }}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>标题</label>
                </div>
                <div class="form-value">
                    <span>{{ transVoucherInfo.memo }}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>退还调拨单</span>
        </div>
        <div class="table-layout">
            <el-table ref="multipleTable" :data="returnVoucherList" maxHeight="500" border tooltip-effect="dark" style="width: 100%">
                <el-table-column align="center" prop="innerNo" label="自有退还单号" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" prop="srcVoucherInnerNo" label="原调拨单号" width="180" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="dstBizUnitName" label="申请部门" width="280" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="srcBizUnitName" label="调出部门" width="280" show-overflow-tooltip></el-table-column>
                <el-table-column align="center" label="完成状态" width="100" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span v-if="rows.row.confirmState == 1" class="font-green">已完成</span>
                        <span v-else class="font-red">未完成</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="confirmTime" label="确认时间" width="180" show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="confirmerName" label="确认人" width="180" show-overflow-tooltip></el-table-column>
            </el-table>
        </div>
        <div class="simple-row">
            <div class="left">
                <el-button type="primary" @click="selectDevice()">选择调拨项</el-button>
            </div>
        </div>
        <div class="table-layout">
            <el-table ref="multipleTable" :data="itemList" maxHeight="500" border tooltip-effect="dark" style="width: 100%">
                <el-table-column align="left" prop="title" label="资产描述全称" fixed show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="model" label="型号" fixed show-overflow-tooltip></el-table-column>
                <el-table-column align="left" prop="fixedSpec" label="规格" fixed show-overflow-tooltip></el-table-column>
                <el-table-column label="资产基础信息" align="center">
                    <el-table-column align="left" prop="name" min-width="150" label="名称" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="tmpNo" min-width="250" label="系统编号" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="innerCode" min-width="250" label="资产编号" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="catName" width="100" label="分类" show-overflow-tooltip></el-table-column>
                    <el-table-column align="left" prop="groupName" width="120" label="维保分组" show-overflow-tooltip>
                        <template slot-scope="rows">
                            <span>{{ getGoodsCatDevcGroupName(rows.row.catId) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="left" prop="brandName" width="150" label="品牌" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="assetKindName" label="财务类别" width="150" align="left" show-overflow-tooltip></el-table-column>
                </el-table-column>
                <el-table-column label="调拨信息" align="center">
                    <el-table-column align="left" prop="srcComFullName" width="100" label="调出部门全称"></el-table-column>
                    <el-table-column align="left" prop="srcWarehouseName" width="100" label="调出仓库"></el-table-column>
                    <el-table-column align="right" prop="directQuantity" width="100" label="退还数量"></el-table-column>
                    <el-table-column align="right" prop="receiptQuantity" width="100" label="验收数量"></el-table-column>
                    <el-table-column align="right" prop="transQuantity" width="100" label="调拨数量"></el-table-column>
                    <el-table-column align="right" prop="quantity" label="退还数量" width="80">
                        <template slot-scope="scope">
                            <el-input type="number" min="0" :disabled="true" class="input-content-right" @change="transAvQuantityChange(scope);" v-model.number="scope.row.quantity"></el-input>
                        </template>
                    </el-table-column>
                </el-table-column>
                <el-table-column label="附加信息" align="center">
                    <el-table-column align="center" prop="theUnit" min-width="100" label="单位"></el-table-column>
                </el-table-column>

                <el-table-column label="资产价值" align="center">
                    <el-table-column align="left" min-width="100" label="入账方式">
                        <template slot-scope="rows">
                            <span>{{ acctEnterWayMap[rows.row.acctEnterWay] }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="orgWorth" width="80" label="原值(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.orgWorth != null">{{ rows.row.orgWorth.toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="right" prop="netWorth" width="80" label="净值(元)">
                        <template slot-scope="rows">
                            <span v-if="rows.row.netWorth != null">{{ rows.row.netWorth.toFixed(2) }}</span>
                        </template>
                    </el-table-column>
                </el-table-column>

            </el-table>
        </div>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { Vue, MsgBox, Routes } from '../../app.vues'
import { getDefaultPageSizes } from '../../app.conf'
import { getDevcGroupNameByCatId } from '../index'
import { openShopDeviceTransVoucherItemSelectDlg } from './showDetailDlg'
import { openBizDepartDlg } from '../orgStruct/selectDlg'

import assetVchrApi from '../../api/assetVchr'
import shopStockApi from '../../api/shopStock'

export default {
    name: 'swb-trans-voucher-return',
    avlActions: '',
    avlScopes: 'vendor',
    notAsResc: true,
    authen: false,
    desc: '调拨单验收-详情',
    props: ['id'],
    data: function () {
        return {
            transVoucherInfo: {},
            returnVoucherList: [],
            itemList: [],
            //
            acctEnterWayMap: {}
        }
    },
    created: function () {
        this.acctEnterWayMap = getEnumMap('acctEnterWay', 'value2text');
        this.getShopDeviceTransVoucher();
    },
    methods: {
        // 数量变化校验
        transAvQuantityChange: function (scope) {
            let items = this.itemList;
            items.forEach(function (item) {
                if(item.transVoucherItemId == scope.row.transVoucherItemId) {
                    if(item.quantity < 0) {
                        Toast.show('数量不可小于0');
                        return;
                    }
                    if((item.transQuantity - item.directQuantity - item.receiptQuantity) < item.quantity) {
                        Toast.show('当前退还数量' + item.quantity + '，大于可退还数量：' + (item.transQuantity - item.directQuantity - item.receiptQuantity), 2000, 'info');
                        return;
                    }
                }
            });
        },
        getAllotAcntType: function (item, callBack) {
            let theLoad = MsgBox.loading();
            let postData = {
                dstComId: item.dstComId,
                srcComId: item.srcComId
            };
            assetVchrApi.getShopDeviceTransVoucherAllotAcntType(postData, function (result) {
                theLoad.hide();
                if(result.type === 'info') {
                    //
                    callBack(result.data)
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        getGoodsCatDevcGroupName: function (catId) {
            return getDevcGroupNameByCatId(catId);
        },
        getShopDeviceTransVoucher: function () {
            let self = this;
            let postData = {};
            postData.id = self.id;
            let theLoading = MsgBox.loading();
            assetVchrApi.getShopDeviceTransVoucher(postData, function (result) {
                theLoading.close();
                if(result.type == 'info') {
                    self.transVoucherInfo = result.data || {};
                    //
                    self.getShopDeviceTransVoucherList(self.transVoucherInfo);
                } else {
                    MsgBox.warning(result.message);
                }
            })
        },
        getShopDeviceTransVoucherList: function (transVoucherInfo) {
            let filterItems = {};
            filterItems.srcRetailerId = transVoucherInfo.srcRetailerId;
            filterItems.deriveId = transVoucherInfo.id;
            filterItems.directFlag = -1;
            filterItems.fiscalAcctFlag = true;  // 资产退换单
            //
            let theLoad = MsgBox.loading();
            assetVchrApi.getShopDeviceTransVoucherNoPageList(filterItems, (result) => {
                theLoad.hide();
                if(result.type === 'info') {
                    this.returnVoucherList = result.data || [];
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 选择调拨项
        selectDevice: function () {
            let self = this;
            let id = self.id;
            let selectIds = self.itemList.pluck('transVoucherItemId') || [];
            openShopDeviceTransVoucherItemSelectDlg(id, selectIds, function (result) {
                let itemList = result || [];
                //
                if(itemList.length > 0) {
                    itemList.forEach(function (item) {
                        item.transQuantity = item.quantity;
                        item.quantity = item.quantity - (item.receiptQuantity || 0) - (item.directQuantity || 0)
                    });
                    self.itemList = Utils.merge([], itemList);
                }
            })
        },
        getDlgResult: function () {
            let result = {};
            result.type = 'info';
            // ---------
            let itemList = this.itemList || [];
            if(itemList.length > 0) {
                let submitFlag = true;
                let message = null;
                itemList.forEach(function (item) {
                    if(Utils.isTrue(item.durable)) {
                        if(Utils.isNoB(item.quantity) || item.quantity <= 0) {
                            message = item.title + '当前退还数量必须大于0';
                            submitFlag = false;
                        }
                        if((item.transQuantity - item.directQuantity - item.receiptQuantity) < item.quantity) {
                            message = item.title + '当前退还数量' + item.quantity + '，大于可退还数量：' + (item.transQuantity - item.directQuantity - item.receiptQuantity);
                            submitFlag = false;
                        }
                    }
                });
                if(Utils.isTrue(submitFlag)) {
                    let transVoucherInfo = this.transVoucherInfo;
                    transVoucherInfo.itemList = itemList;
                    result.data = transVoucherInfo;
                } else {
                    result.type = 'warn';
                    result.message = message;
                }
            } else {
                result.type = 'warn';
                result.message = '请选择资产信息！';
            }
            return result;
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/transVoucher/ShopDeviceTransVoucherReturnSave.vue